module.exports = __webpack_public_path__ + "img/icon-navigation-expand.13afc831.svg";